module.exports = __webpack_public_path__ + "img/icon_pin-g.70db25e8.svg";